module.exports = __webpack_public_path__ + "img/bill1.36ae5037.png";